import { ProductLocator } from './ProductLocator'

export const components = {
    product_locator_module: ProductLocator
}